import styled from "styled-components"

import { color } from "../../../atoms/colors"

export const Section = styled.section`
  display: flex;
  flex-direction: column;
  gap: 64px;
  position: relative;
  padding: 48px 0px 192px 0px;
  background: linear-gradient(
      180deg,
      ${color.common.white} 71.87%,
      rgba(255, 255, 255, 0) 99.99%,
      rgba(0, 0, 0, 0) 100%
    ),
    linear-gradient(250.72deg, #abe2f4 -8.68%, #f0f7e9 62.92%, #edfbff 117.43%);
  @media (max-width: 992px) {
    padding: 56px 0px 142px 0px;
    gap: 48px;
  }
  @media (max-width: 992px) {
    padding: 40px 0px 112px 0px;
    gap: 32px;
  }
  @media (max-width: 576px) {
    padding: 40px 0px 80px 0px;
  }
`
export const Wrapper = styled.div`
  width: 100%;
  max-width: 1230px;
  padding: 0px 30px;
  margin: 0 auto;
  @media (max-width: 992px) {
    max-width: 830px;
  }
`

export const Header = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin-bottom: 64px;
  @media (max-width: 992px) {
    margin-bottom: 48px;
  }
  @media (max-width: 992px) {
    margin-bottom: 32px;
  }
  @media (max-width: 320px) {
    margin-bottom: 48px;
  }
`

export const Eyebrow = styled.div`
  font-family: "Avenir";
  font-style: normal;
  font-weight: 800;
  font-size: 16px;
  line-height: 24px;
  text-transform: uppercase;
  color: ${color.primary[700]};
  @media (max-width: 576px) {
    font-size: 12px;
    line-height: 18px;
  }
`

export const Heading = styled.div`
  font-family: "Avenir";
  font-style: normal;
  font-weight: 900;
  font-size: 48px;
  line-height: 60px;
  letter-spacing: -0.02em;
  color: ${color.oxfordBlue[900]};
  @media (max-width: 991px) {
    font-size: 36px;
    line-height: 44px;
    letter-spacing: -0.02em;
  }
  @media (max-width: 576px) {
    font-size: 24px;
    line-height: 32px;
  }
`

export const Subhead = styled.div`
  font-family: "Avenir";
  font-style: normal;
  font-weight: 400;
  font-size: 18px;
  line-height: 24px;
  color: ${color.copy[700]};
  max-width: 770px;
  @media (max-width: 992px) {
    font-weight: 350;
    font-size: 16px;
  }
`

export const CallToAction = styled.a`
  width: max-content;
  color: ${color.common.linkBlue};
  transition: all 450ms ease-in-out 0s;
  &.arrow-link {
    position: relative;
    text-decoration: none;
    font-weight: 850;
    font-size: 20px;
    line-height: 24px;
    padding-right: 15px;
    top: 8px;
    cursor: pointer;
    &:hover {
      color: ${color.primary[200]};
    }
    &:before,
    &:after {
      border-right: 2px solid;
      content: "";
      display: block;
      height: 8px;
      margin-top: -6px;
      position: absolute;
      transform: rotate(135deg);
      right: 0;
      top: 54%;
      width: 0;
    }
    :after {
      margin-top: -1px;
      transform: rotate(45deg);
    }
    @media (max-width: 992px) {
      font-size: 16px;
    }
  }
`

export const CardsWrapper = styled.div`
  display: flex;
  @media (max-width: 992px) {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
  }
  @media (max-width: 320px) {
    grid-template-columns: repeat(1, 1fr);
  }
`

export const BackgroundTreatment = styled.div`
  position: absolute;
  top: 48px;
  right: 0px;
  @media (max-width: 1200px) {
    display: none;
  }
`
